/*
  HWK ACTIONS
 */
export const FETCH_REGIONS = "FETCH_REGIONS";
export const FETCH_REGIONS_SUCCESS = "FETCH_REGIONS_SUCCESS";
export const FETCH_REGIONS_FAILURE = "FETCH_REGIONS_FAILURE";
export const CREATE_REGION = "CREATE_REGION";
export const UPDATE_REGION = "UPDATE_REGION";
export const DELETE_REGION = "DELETE_REGION";

export const FETCH_SPORT_TYPES = "FETCH_SPORT_TYPES";
export const FETCH_SPORT_TYPES_SUCCESS = "FETCH_SPORT_TYPES_SUCCESS";
export const FETCH_SPORT_TYPES_FAILURE = "FETCH_SPORT_TYPES_FAILURE";
export const UPDATE_SPORT_TYPE = "UPDATE_SPORT_TYPE";
export const UPDATE_SPORT_TYPE_SUCCESS = "UPDATE_SPORT_TYPE_SUCCESS";
export const UPDATE_SPORT_TYPE_FAILURE = "UPDATE_SPORT_TYPE_FAILURE";
export const CREATE_SPORT_TYPE = "CREATE_SPORT_TYPE";
export const CREATE_SPORT_TYPE_SUCCESS = "CREATE_SPORT_TYPE_SUCCESS";
export const CREATE_SPORT_TYPE_FAILURE = "CREATE_SPORT_TYPE_FAILURE";
export const DELETE_SPORT_TYPE = "DELETE_SPORT_TYPE";

export const FETCH_SPORT_VARIANTS = "FETCH_SPORT_VARIANTS";
export const FETCH_SPORT_VARIANTS_SUCCESS = "FETCH_SPORT_VARIANTS_SUCCESS";
export const FETCH_SPORT_VARIANTS_FAILURE = "FETCH_SPORT_VARIANTS_FAILURE";
export const UPDATE_SPORT_VARIANT = "UPDATE_SPORT_VARIANT";
export const CREATE_SPORT_VARIANT = "CREATE_SPORT_VARIANT";
export const DELETE_SPORT_VARIANT = "DELETE_SPORT_VARIANT";

export const FETCH_CONDITIONS = "FETCH_CONDITIONS";
export const FETCH_CONDITIONS_SUCCESS = "FETCH_CONDITIONS_SUCCESS";
export const FETCH_CONDITIONS_FAILURE = "FETCH_CONDITIONS_FAILURE";
export const UPDATE_CONDITION = "UPDATE_CONDITION";
export const CREATE_CONDITION = "CREATE_CONDITION";
export const DELETE_CONDITION = "DELETE_CONDITION";

export const FETCH_PRODUCTS = "FETCH_PRODUCTS";
export const FETCH_PRODUCTS_SUCCESS = "FETCH_PRODUCTS_SUCCESS";
export const FETCH_PRODUCTS_FAILURE = "FETCH_PRODUCTS_FAILURE";
export const CREATE_PRODUCT = "CREATE_PRODUCT";
export const UPDATE_PRODUCT = "UPDATE_PRODUCT";
export const UPDATE_PRODUCT_PHOTO = "UPDATE_PRODUCT_PHOTO";
export const DELETE_PRODUCT = "DELETE_PRODUCT";

export const FETCH_PRODUCT_VIDEOS = "FETCH_PRODUCT_VIDEOS";
export const FETCH_PRODUCT_VIDEOS_SUCCESS = "FETCH_PRODUCT_VIDEOS_SUCCESS";
export const FETCH_PRODUCT_VIDEOS_FAILURE = "FETCH_PRODUCT_VIDEOS_FAILURE";
export const CREATE_PRODUCT_VIDEO = "CREATE_PRODUCT_VIDEO";
export const DELETE_PRODUCT_VIDEO = "DELETE_PRODUCT_VIDEO";

export const CONFIGURATOR_SELECT_NODE = "CONFIGURATOR_SELECT_NODE";

export const ADVISOR_SET_REGION = "ADVISOR_SET_REGION";
export const ADVISOR_SET_SPORT_TYPE = "ADVISOR_SET_SPORT_TYPE";
export const ADVISOR_SET_SPORT_VARIANT = "ADVISOR_SET_SPORT_VARIANT";
export const ADVISOR_UNSET_SPORT_VARIANT = "ADVISOR_UNSET_SPORT_VARIANT";
export const ADVISOR_SET_PARAMETERS = "ADVISOR_SET_PARAMETERS";

export const WISHLIST_TOGGLE_PRODUCT = "WISHLIST_TOGGLE_PRODUCT";
export const WISHLIST_SET_EMAIL = "WISHLIST_SET_EMAIL";
export const WISHLIST_SHOW_EMAIL_FORM = "WISHLIST_SHOW_EMAIL_FORM";
export const WISHLIST_HIDE_EMAIL_FORM = "WISHLIST_HIDE_EMAIL_FORM";
export const WISHLIST_SEND_TO_EMAIL = "WISHLIST_SEND_TO_EMAIL";

export const FETCH_WEATHER_PROVIDERS = "FETCH_WEATHER_PROVIDERS";
export const FETCH_WEATHER_PROVIDERS_SUCCESS = "FETCH_WEATHER_PROVIDERS_SUCCESS";
export const FETCH_WEATHER_PROVIDERS_FAILURE = "FETCH_WEATHER_PROVIDERS_FAILURE";
export const CREATE_WEATHER_PROVIDER = "CREATE_WEATHER_PROVIDER";
export const UPDATE_WEATHER_PROVIDER = "UPDATE_WEATHER_PROVIDER";
export const DELETE_WEATHER_PROVIDER = "DELETE_WEATHER_PROVIDER";
